







































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import BaseModal from '~/components/modals/BaseModal.vue';
import RatingKpis from '~/components/partials/RatingKpis.vue';
import Review from '~/components/lists/items/Review.vue';

@Component({
  components: { BaseModal, RatingKpis, Review },
})
export default class AllRatingsModal extends Vue {
  @Prop(Number) averageRatesNote: 0;
  @Prop(Array) ratings: [];

  /* Emits a close event to the BaseModal parent to close modal */
  @Emit('modal-close')
  close () {}
};
